import ko from './ko.json';

const resources = {
  ...ko,
};

export default resources;
